"use client";

import { ArrowRight, ArrowUpRight } from "lucide-react";
import { APP_URLS } from "@/utils/constants";
import useSession from "@/hooks/useSession";

const CTA_CLASS =
  "inline-flex items-center justify-center gap-2 h-[46px] sm:h-[48px] px-8 w-full sm:w-auto max-w-[320px] sm:max-w-none bg-black hover:bg-[#171717] text-white geist-semibold text-sm sm:text-base rounded-lg shadow-md hover:shadow-lg transition-all duration-300";

/**
 * Primary CTA on the Books / CRM product pages. Falls back to the demo link
 * unless the signed in company has a live subscription for `app`.
 *
 * @param {"BOOKS"|"CRM"} app
 * @param {string} demoLabel - copy shown to everyone without access
 */
export default function ProductHeroCta({ app, demoLabel }) {
  const { apps } = useSession();

  if (apps[app]) {
    return (
      <a
        href={APP_URLS[app]}
        target="_blank"
        rel="noopener noreferrer"
        className={CTA_CLASS}
      >
        <span>Access Now</span>
        <ArrowUpRight className="w-4 h-4" />
      </a>
    );
  }

  return (
    <a href="/contact" className={CTA_CLASS}>
      <span>{demoLabel}</span>
      <ArrowRight className="w-4 h-4" />
    </a>
  );
}
